const provinceField = {
  component: 'TextFieldHiddenSchema',
  maxLength: 60,
};

export default provinceField;
